import { Observable } from 'rxjs'
import { OrgHierarchy } from '../models/orgHeirarchy'
import { GoodStandingModel } from '../models/good-standing-model'
export abstract class CommonGateway {
    abstract getOrgHierarchy(orgId: number): Observable<OrgHierarchy[]>
    abstract getGoodStandingStatus(userProfileId: number, planYear: string): Observable<boolean>
    abstract getGlobalLinks(orgId: number, planYear: string)
    abstract getOrgIPV(orgId: number): Observable<number[]>
    abstract getHelpLocation(planYear: number): Observable<string>
    abstract getGoodStandingDetails(userProfileId: number, planYear: string): Observable<GoodStandingModel>
    abstract getIPVString(orgIPV: string): Observable<string>
}
